import _ from "lodash";
window._ = _;

import { algoliasearch } from "algoliasearch";
window.algoliasearch = algoliasearch;

import Swiper from "swiper/bundle";
window.Swiper = Swiper;

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import ui from "@alpinejs/ui";

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(ui);

Alpine.start();
